import { Injectable, signal } from "@angular/core";

interface Toaster {
    id: number;
    heading: string;
    description: string;
    type: string;
}

@Injectable()
export class ToasterService {
    private nextId = 0;
    private maxToasters = 1;
    // Signal replaces the previous `toastersSubject` BehaviorSubject / `toasters$` observable.
    public readonly toasters = signal<Toaster[]>([]);

    showToaster(heading: string, description: string, type: string) {
        const newToaster: Toaster = {
            id: this.nextId++,
            heading: heading,
            description: description,
            type: type
        };

        this.toasters.update(current => {
            const next = current.length >= this.maxToasters ? current.slice(1) : current;
            return [...next, newToaster];
        });
    }

    hideToaster(id: number) {
        this.toasters.update(current => current.filter(toaster => toaster.id !== id));
    }

    hideAllToasters() {
        this.toasters.set([]);
    }
}
